<template>
  <div>
    <div class="main_Container">
      <section class="p-4 detailsView">
        <div class="container-fluid container-xxl">
          <div v-show="loading" class="data__loading">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div class="row" v-show="!loading">
            <main class="col-lg-8">
              <figure class="card w-100">
                <blockquote class="card-body m-0 p-2">
                  <iframe :src="content.additional_url" frameborder="0" class="video-preview"
                    v-if="content.additional_url"></iframe>
                  <div v-else v-html="content.embed" class="video-preview-box"></div>
                  <!-- <embed src="https://www.youtube.com/watch?v=b63vGc6WW0A" class="video-preview" type="" /> -->
                </blockquote>
              </figure>
              <figure class="card w-100">
                <div class="card-header p-3">
                  <h3 class="card-header-title text-muted">محتوى الفيديو</h3>
                </div>
                <blockquote class="card-body m-0 p-3">
                  <h5>{{ content.title }}</h5>
                  <p class="m-0">{{ content.description }}</p>
                </blockquote>
              </figure>
              <div>
                <ul class="card-container mx-0 w-100 p-0 -m-4 mb-3">
                  <li class="p-2">
                    <div class="p-3 card">
                      <div class="d-flex align-items-center">
                        <div class="btn bg-light">
                          <i class="fas fa-users"></i>
                        </div>
                        <div class="col mx-3">
                          <h4 class="text-nowrap">{{ analytics.payments || 0 }}</h4>
                          <div class="overflow-hidden">
                            <p class="text-muted text-truncate fs-6 fw-bold m-0">عدد الطلاب</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="p-2">
                    <div class="p-3 card">
                      <div class="d-flex align-items-center">
                        <div class="btn bg-light">
                          <i class="fas fa-dollar-sign"></i>
                        </div>
                        <div class="col mx-3">
                          <h4 class="text-nowrap">{{ content.price }}</h4>
                          <div class="overflow-hidden">
                            <p class="text-muted text-truncate fs-6 fw-bold m-0">السعر</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="p-2">
                    <div class="p-3 card">
                      <div class="d-flex align-items-center">
                        <div class="btn bg-light">
                          <i class="fas fa-eye"></i>
                        </div>
                        <div class="col mx-3">
                          <h4 class="text-nowrap">{{ analytics.views || 0 }}</h4>
                          <div class="overflow-hidden">
                            <p class="text-muted text-truncate fs-6 fw-bold m-0">المشاهدات</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="p-2">
                    <div class="p-3 card">
                      <div class="d-flex align-items-center">
                        <div class="btn bg-light">
                          <i class="fas fa-comments"></i>
                        </div>
                        <div class="col mx-3">
                          <h4 class="text-nowrap">{{ comments.count || 0 }}</h4>
                          <div class="overflow-hidden">
                            <p class="text-muted text-truncate fs-6 fw-bold m-0">التعليقات</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <figure class="card w-100" id="comments">
                <div class="card-header p-3">
                  <h3 class="card-header-title text-muted">التعليقات</h3>
                </div>
                <blockquote class="card-body m-0 p-3 position-relative">
                  <ul class="comments-replies-list p-0 m-0">
                    <SingleCommentItem v-for="(item, index) in comments.comments" :key="index" :comment="item" />
                  </ul>
                  <div class="load-more" v-if="(comments.comments || []).length < comments.count"
                    @click.prevent="loadMore">
                    <button class="btn btn-dark">تحميل المزيد</button>
                  </div>

                  <div v-if="(comments.comments || []).length === 0">
                    <p class="text-center text-muted">ليس هناك تعليقات</p>
                  </div>
                </blockquote>
                <div class="card-footer p-3">
                  <form class="w-100" @submit.prevent="createNewComment">
                    <div class="d-flex flex-lg-row flex-column gap-2 gap-lg-3 align-items-end">
                      <div class="col-lg w-100">
                        <div class="form-group m-0">
                          <textarea class="form-control" id="comment-content" name="comment-content"
                            placeholder="اكتب تعلقيك هنا.." required style="min-height: 50px"
                            v-model="add_data.comment">
                          </textarea>
                        </div>
                      </div>
                      <div>
                        <button class="btn btn-dark" type="submit" :disabled="add_disabled || !add_data.comment">
                          <i class="fas fa-spinner fa-spin" v-if="add_disabled"></i>
                          ارسال تعليقك
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </figure>
            </main>
            <aside class="col-lg-4">
              <figure class="card w-100">
                <div class="card-header p-3">
                  <h3 class="card-header-title text-muted">المرفقات</h3>
                </div>
                <blockquote class="card-body p-0 m-0">
                  <ul class="attachments_list">
                    <li class="attachment_item" v-for="(file, index) in attachments" :key="index">
                      <a :href="file.url" target="_blank" rel="noopener noreferrer" :title="file.title"
                        style="text-decoration: none; color: unset">
                        <div class="attachment_body">
                          <div class="attachment_icon">
                            <i class="fas fa-file"></i>
                          </div>
                          <div class="attachment_content">
                            <h5>{{ file.title }}</h5>
                            <p>{{ file.created_date }}</p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li v-if="attachments.length === 0">
                      <div>
                        <p class="text-center text-muted">ليس هناك مرفقات</p>
                      </div>
                    </li>
                  </ul>
                </blockquote>
                <footer class="card-footer p-3">
                  <button class="btn btn-dark rounded mx-auto" type="button" data-bs-toggle="modal"
                    data-bs-target="#addAttachment">
                    <i class="fas fa-pen mr-1"></i>
                    اضف مرفق
                  </button>
                </footer>
              </figure>
            </aside>
          </div>
        </div>
      </section>
    </div>
    <UploadAttachments />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SingleCommentItem from '@/components/SingleCommentItem.vue';
import UploadAttachments from '@/components/videos/UploadAttachments.vue';
import { Timestamp } from '@firebase/firestore';
export default {
  name: 'ViewVideo',
  data() {
    return {
      // id: this.$route.params.video_id,
      // lesson_id: this.$route.params.index,
      add_data: {},
      add_disabled: false,
    };
  },
  computed: {
    ...mapGetters('ViewVideoModule', ['content', 'loading', 'analytics', 'comments', 'attachments']),
    ...mapGetters('adminModule', ['getUser']),
    video_id() {
      return this.$route.params.video_id;
    },
    lesson_id() {
      return this.$route.params.index;
    },
  },
  methods: {
    ...mapActions('ViewVideoModule', ['getSingleVideo', 'getVideoContents', 'getVideoCommentsAndLoad', 'addComment', 'getAttachments']),
    async createNewComment() {
      const user = this.getUser;
      const data = {
        comment: this.add_data.comment,
        created_date: Timestamp.now().toDate().toISOString(),
        created_at: new Date().toDateString(),
        content_id: this.video_id,
        user_id: this.getUser.uid,
        author: { avatar_url: user.photo, user_name: `${user.firstName} ${user.lastName}`, user_id: user.uid, grade: null, is_teacher: true },
        replies: {},
      };
      await this.addComment({
        video_id: this.video_id,
        comment: data,
        path: this.$route.path,
      });
      // remove data
      this.add_data = {};
    },
    async loadMore() {
      await this.getVideoCommentsAndLoad(this.video_id);
    },
  },
  async created() {
    console.log(this.$route.params);
    await Promise.all([
      await this.getSingleVideo(this.video_id),
      await this.getAttachments(this.video_id),
      await this.getVideoContents({
        lesson_id: this.lesson_id,
        video_id: this.video_id,
      }),
      await this.getVideoCommentsAndLoad(this.video_id),
    ]);
  },
  components: { SingleCommentItem, UploadAttachments },
};
</script>

<style lang="scss">
@import '@/scss/pages/viewVideo';
</style>
